/* eslint-disable implicit-arrow-linebreak */
import { getNotificationListApi } from 'pages/Notifications/api/NotificationApis';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RootState } from 'modules/rootReducer';
import { message } from 'antd';
import { isConnectionError } from '../checkAxiosError';

const bookRoute = '/offline/books';

export const retryAndRedirectToBook = async (query: Promise<any>, retry: number = 5): Promise<any> => {
  try {
    const response = await query;
    message.destroy();
    return response;
  } catch (error) {
    if (isConnectionError(error)) {
      message.open({
        key: 'offlineRetry',
        type: 'loading',
        content: 'Không thể kết nối hệ thống, đang thử lại...',
        duration: 0,
      });
      if (retry > 0) {
        await new Promise((resolve) => setTimeout(resolve, 3000));
        await retryAndRedirectToBook(query, retry - 1);
      }
      message.destroy();
      window.location.href = bookRoute;
      return null;
    }
    throw error;
  }
};

export default function RedirectToBook() {
  const loggedInUser = useSelector((state: RootState) => state.authReducer.loggedInUser);
  const history = useHistory();
  const KEY_GET_NOTIFICATIONS = 'p_SACHSO_ThongBao_NguoiDung_DanhSach';
  const { data: notificationList } = useQuery(
    KEY_GET_NOTIFICATIONS,
    () =>
      getNotificationListApi({
        UserId: loggedInUser?.id ?? 0,
        PageNum: 1,
        PageSize: 8,
      }),
    {
      onError: (error) => {
        message.destroy();
        if (isConnectionError(error)) {
          history.push(bookRoute);
        }
      },
      retry: (failureCount, error) => {
        if (isConnectionError(error) && failureCount < 5) {
          message.open({
            key: 'offlineRetry',
            type: 'loading',
            content: 'Không thể kết nối hệ thống, đang thử lại...',
            duration: 0,
          });
          return true;
        }
        message.destroy();
        return false;
      },
      retryDelay: 3000, // Retry every 3 seconds
    },
  );
  return <></>;
}
